/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * jeeves/v1/api.proto
 * OpenAPI spec version: version not set
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  ListRunsParams,
  QueryDailyRunAggregatesParams,
  RpcStatus,
  RunServiceArchiveRunsBody,
  RunServiceContinueRunBody,
  RunServicePauseRunBody,
  V1ArchiveRunsResponse,
  V1CreateRunRequest,
  V1GetRunCodeManifestResponse,
  V1ListRunExecutionsRequest,
  V1ListRunExecutionsResponse,
  V1ListRunsResponse,
  V1PatchRunStepRequest,
  V1QueryAutomationRunAggregatesResponse,
  V1QueryDailyRunAggregatesResponse,
  V1ReplayRunRequest,
  V1ResumeRunRequest,
  V1RetryRunStepRequest,
  V1Run,
  V1SkipRunStepRequest,
} from '../models';

/**
 * @summary Lists runs with optional pagination support.
Returns a paginated list of runs accessible to the caller.
 */
export const listRuns = (
  organization: string,
  workspace: string,
  automation: string,
  params?: ListRunsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListRunsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListRunsInfiniteQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: ListRunsParams,
) => {
  return [
    'infinite',
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListRunsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: ListRunsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListRunsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listRuns>>,
    ListRunsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListRunsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listRuns>>,
        TError,
        TData,
        QueryKey,
        ListRunsParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListRunsInfiniteQueryKey(organization, workspace, automation, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRuns>>,
    QueryKey,
    ListRunsParams['page_token']
  > = ({ signal, pageParam }) =>
    listRuns(
      organization,
      workspace,
      automation,
      { ...params, page_token: pageParam || params?.['page_token'] },
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listRuns>>,
    TError,
    TData,
    QueryKey,
    ListRunsParams['page_token']
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListRunsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRuns>>
>;
export type ListRunsInfiniteQueryError = AxiosError<RpcStatus>;

export function useListRunsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listRuns>>,
    ListRunsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: undefined | ListRunsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listRuns>>,
        TError,
        TData,
        QueryKey,
        ListRunsParams['page_token']
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRuns>>,
          TError,
          Awaited<ReturnType<typeof listRuns>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRunsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listRuns>>,
    ListRunsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListRunsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listRuns>>,
        TError,
        TData,
        QueryKey,
        ListRunsParams['page_token']
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRuns>>,
          TError,
          Awaited<ReturnType<typeof listRuns>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRunsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listRuns>>,
    ListRunsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListRunsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listRuns>>,
        TError,
        TData,
        QueryKey,
        ListRunsParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists runs with optional pagination support.
Returns a paginated list of runs accessible to the caller.
 */

export function useListRunsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listRuns>>,
    ListRunsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListRunsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listRuns>>,
        TError,
        TData,
        QueryKey,
        ListRunsParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListRunsInfiniteQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListRunsQueryOptions = <
  TData = Awaited<ReturnType<typeof listRuns>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListRunsQueryKey(organization, workspace, automation, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listRuns>>> = ({
    signal,
  }) =>
    listRuns(organization, workspace, automation, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListRunsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRuns>>
>;
export type ListRunsQueryError = AxiosError<RpcStatus>;

export function useListRuns<
  TData = Awaited<ReturnType<typeof listRuns>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: undefined | ListRunsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRuns>>,
          TError,
          Awaited<ReturnType<typeof listRuns>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRuns<
  TData = Awaited<ReturnType<typeof listRuns>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRuns>>,
          TError,
          Awaited<ReturnType<typeof listRuns>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRuns<
  TData = Awaited<ReturnType<typeof listRuns>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists runs with optional pagination support.
Returns a paginated list of runs accessible to the caller.
 */

export function useListRuns<
  TData = Awaited<ReturnType<typeof listRuns>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listRuns>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListRunsQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Retrieves a specific run by its unique identifier.
Returns the current state and metadata of the run.
 */
export const getRun = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Run>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}`,
    options,
  );
};

export const getGetRunQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}`,
  ] as const;
};

export const getGetRunQueryOptions = <
  TData = Awaited<ReturnType<typeof getRun>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRunQueryKey(organization, workspace, automation, run);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRun>>> = ({
    signal,
  }) =>
    getRun(organization, workspace, automation, run, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && run),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetRunQueryResult = NonNullable<Awaited<ReturnType<typeof getRun>>>;
export type GetRunQueryError = AxiosError<RpcStatus>;

export function useGetRun<
  TData = Awaited<ReturnType<typeof getRun>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRun>>,
          TError,
          Awaited<ReturnType<typeof getRun>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRun<
  TData = Awaited<ReturnType<typeof getRun>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRun>>,
          TError,
          Awaited<ReturnType<typeof getRun>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRun<
  TData = Awaited<ReturnType<typeof getRun>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves a specific run by its unique identifier.
Returns the current state and metadata of the run.
 */

export function useGetRun<
  TData = Awaited<ReturnType<typeof getRun>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRun>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRunQueryOptions(
    organization,
    workspace,
    automation,
    run,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The manifest is derived server-side from the run's stored executable code
by calling Jarvis's PrepareCodeManifest internally — the raw code itself
is never returned to the caller. If the stored code fails validation
(unexpected, since it already executed as part of this run), the RPC
fails with an error instead of returning a partial result.
 * @summary Returns the code manifest describing the structure of the Main-phase code
this run actually executed, and its rendered AOP (SOP) text.
 */
export const getRunCodeManifest = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetRunCodeManifestResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}:codeManifest`,
    options,
  );
};

export const getGetRunCodeManifestQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}:codeManifest`,
  ] as const;
};

export const getGetRunCodeManifestQueryOptions = <
  TData = Awaited<ReturnType<typeof getRunCodeManifest>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRunCodeManifest>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRunCodeManifestQueryKey(organization, workspace, automation, run);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRunCodeManifest>>
  > = ({ signal }) =>
    getRunCodeManifest(organization, workspace, automation, run, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && run),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRunCodeManifest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRunCodeManifestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRunCodeManifest>>
>;
export type GetRunCodeManifestQueryError = AxiosError<RpcStatus>;

export function useGetRunCodeManifest<
  TData = Awaited<ReturnType<typeof getRunCodeManifest>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRunCodeManifest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRunCodeManifest>>,
          TError,
          Awaited<ReturnType<typeof getRunCodeManifest>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRunCodeManifest<
  TData = Awaited<ReturnType<typeof getRunCodeManifest>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRunCodeManifest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRunCodeManifest>>,
          TError,
          Awaited<ReturnType<typeof getRunCodeManifest>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRunCodeManifest<
  TData = Awaited<ReturnType<typeof getRunCodeManifest>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRunCodeManifest>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the code manifest describing the structure of the Main-phase code
this run actually executed, and its rendered AOP (SOP) text.
 */

export function useGetRunCodeManifest<
  TData = Awaited<ReturnType<typeof getRunCodeManifest>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRunCodeManifest>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRunCodeManifestQueryOptions(
    organization,
    workspace,
    automation,
    run,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Continues a run that has been stopped by a user.
Returns the current state and metadata of the run.
 */
export const continueRun = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  runServiceContinueRunBody: RunServiceContinueRunBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Run>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}:continue`,
    runServiceContinueRunBody,
    options,
  );
};

export const getContinueRunMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof continueRun>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      data: RunServiceContinueRunBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof continueRun>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    data: RunServiceContinueRunBody;
  },
  TContext
> => {
  const mutationKey = ['continueRun'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof continueRun>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      data: RunServiceContinueRunBody;
    }
  > = props => {
    const { organization, workspace, automation, run, data } = props ?? {};

    return continueRun(
      organization,
      workspace,
      automation,
      run,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ContinueRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof continueRun>>
>;
export type ContinueRunMutationBody = RunServiceContinueRunBody;
export type ContinueRunMutationError = AxiosError<RpcStatus>;

/**
 * @summary Continues a run that has been stopped by a user.
Returns the current state and metadata of the run.
 */
export const useContinueRun = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof continueRun>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        data: RunServiceContinueRunBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof continueRun>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    data: RunServiceContinueRunBody;
  },
  TContext
> => {
  const mutationOptions = getContinueRunMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Pause a run that is currently executing.
Returns the current state and metadata of the run.
 */
export const pauseRun = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  runServicePauseRunBody: RunServicePauseRunBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Run>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}:pause`,
    runServicePauseRunBody,
    options,
  );
};

export const getPauseRunMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pauseRun>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      data: RunServicePauseRunBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pauseRun>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    data: RunServicePauseRunBody;
  },
  TContext
> => {
  const mutationKey = ['pauseRun'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pauseRun>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      data: RunServicePauseRunBody;
    }
  > = props => {
    const { organization, workspace, automation, run, data } = props ?? {};

    return pauseRun(
      organization,
      workspace,
      automation,
      run,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PauseRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof pauseRun>>
>;
export type PauseRunMutationBody = RunServicePauseRunBody;
export type PauseRunMutationError = AxiosError<RpcStatus>;

/**
 * @summary Pause a run that is currently executing.
Returns the current state and metadata of the run.
 */
export const usePauseRun = <TError = AxiosError<RpcStatus>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof pauseRun>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        data: RunServicePauseRunBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof pauseRun>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    data: RunServicePauseRunBody;
  },
  TContext
> => {
  const mutationOptions = getPauseRunMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Archives a list of runs by their unique identifiers.
 */
export const archiveRuns = (
  organization: string,
  workspace: string,
  automation: string,
  runServiceArchiveRunsBody: RunServiceArchiveRunsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ArchiveRunsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs:archive`,
    runServiceArchiveRunsBody,
    options,
  );
};

export const getArchiveRunsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveRuns>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: RunServiceArchiveRunsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveRuns>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: RunServiceArchiveRunsBody;
  },
  TContext
> => {
  const mutationKey = ['archiveRuns'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveRuns>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: RunServiceArchiveRunsBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return archiveRuns(organization, workspace, automation, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveRunsMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveRuns>>
>;
export type ArchiveRunsMutationBody = RunServiceArchiveRunsBody;
export type ArchiveRunsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Archives a list of runs by their unique identifiers.
 */
export const useArchiveRuns = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof archiveRuns>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: RunServiceArchiveRunsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof archiveRuns>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: RunServiceArchiveRunsBody;
  },
  TContext
> => {
  const mutationOptions = getArchiveRunsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Queries run stats for all automations in a workspace.
Returns run counts including total runs and completed runs for each automation.
 */
export const queryAutomationRunAggregates = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1QueryAutomationRunAggregatesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}:automationRunAggregates`,
    options,
  );
};

export const getQueryAutomationRunAggregatesQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}:automationRunAggregates`,
  ] as const;
};

export const getQueryAutomationRunAggregatesQueryOptions = <
  TData = Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getQueryAutomationRunAggregatesQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof queryAutomationRunAggregates>>
  > = ({ signal }) =>
    queryAutomationRunAggregates(organization, workspace, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type QueryAutomationRunAggregatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof queryAutomationRunAggregates>>
>;
export type QueryAutomationRunAggregatesQueryError = AxiosError<RpcStatus>;

export function useQueryAutomationRunAggregates<
  TData = Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
          TError,
          Awaited<ReturnType<typeof queryAutomationRunAggregates>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useQueryAutomationRunAggregates<
  TData = Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
          TError,
          Awaited<ReturnType<typeof queryAutomationRunAggregates>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useQueryAutomationRunAggregates<
  TData = Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Queries run stats for all automations in a workspace.
Returns run counts including total runs and completed runs for each automation.
 */

export function useQueryAutomationRunAggregates<
  TData = Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryAutomationRunAggregates>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getQueryAutomationRunAggregatesQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Queries daily aggregated run statistics for a workspace within a date range.
Returns the total number of runs created each day within the specified date range.
 */
export const queryDailyRunAggregates = (
  organization: string,
  workspace: string,
  params: QueryDailyRunAggregatesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1QueryDailyRunAggregatesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}:dailyRunAggregates`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getQueryDailyRunAggregatesQueryKey = (
  organization?: string,
  workspace?: string,
  params?: QueryDailyRunAggregatesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}:dailyRunAggregates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getQueryDailyRunAggregatesQueryOptions = <
  TData = Awaited<ReturnType<typeof queryDailyRunAggregates>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: QueryDailyRunAggregatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryDailyRunAggregates>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getQueryDailyRunAggregatesQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof queryDailyRunAggregates>>
  > = ({ signal }) =>
    queryDailyRunAggregates(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof queryDailyRunAggregates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type QueryDailyRunAggregatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof queryDailyRunAggregates>>
>;
export type QueryDailyRunAggregatesQueryError = AxiosError<RpcStatus>;

export function useQueryDailyRunAggregates<
  TData = Awaited<ReturnType<typeof queryDailyRunAggregates>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: QueryDailyRunAggregatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryDailyRunAggregates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryDailyRunAggregates>>,
          TError,
          Awaited<ReturnType<typeof queryDailyRunAggregates>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useQueryDailyRunAggregates<
  TData = Awaited<ReturnType<typeof queryDailyRunAggregates>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: QueryDailyRunAggregatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryDailyRunAggregates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryDailyRunAggregates>>,
          TError,
          Awaited<ReturnType<typeof queryDailyRunAggregates>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useQueryDailyRunAggregates<
  TData = Awaited<ReturnType<typeof queryDailyRunAggregates>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: QueryDailyRunAggregatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryDailyRunAggregates>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Queries daily aggregated run statistics for a workspace within a date range.
Returns the total number of runs created each day within the specified date range.
 */

export function useQueryDailyRunAggregates<
  TData = Awaited<ReturnType<typeof queryDailyRunAggregates>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: QueryDailyRunAggregatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryDailyRunAggregates>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getQueryDailyRunAggregatesQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates a new run with the specified executable code and inputs.
The run will be queued for execution and assigned a unique identifier.
 */
export const createRun = (
  v1CreateRunRequest: V1CreateRunRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Run>> => {
  return axios.default.post(
    `/jeeves.v1.RunService/CreateRun`,
    v1CreateRunRequest,
    options,
  );
};

export const getCreateRunMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRun>>,
    TError,
    { data: V1CreateRunRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRun>>,
  TError,
  { data: V1CreateRunRequest },
  TContext
> => {
  const mutationKey = ['createRun'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRun>>,
    { data: V1CreateRunRequest }
  > = props => {
    const { data } = props ?? {};

    return createRun(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRun>>
>;
export type CreateRunMutationBody = V1CreateRunRequest;
export type CreateRunMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a new run with the specified executable code and inputs.
The run will be queued for execution and assigned a unique identifier.
 */
export const useCreateRun = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRun>>,
      TError,
      { data: V1CreateRunRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createRun>>,
  TError,
  { data: V1CreateRunRequest },
  TContext
> => {
  const mutationOptions = getCreateRunMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists the executions for a specific run.
Executions are returned in the order they occurred within the run (oldest first).
The full list is returned in a single response; pagination is not supported because
the number of executions per run is naturally bounded (typically a handful, rarely
exceeding low tens).
 */
export const listRunExecutions = (
  v1ListRunExecutionsRequest: V1ListRunExecutionsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListRunExecutionsResponse>> => {
  return axios.default.post(
    `/jeeves.v1.RunService/ListRunExecutions`,
    v1ListRunExecutionsRequest,
    options,
  );
};

export const getListRunExecutionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listRunExecutions>>,
    TError,
    { data: V1ListRunExecutionsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listRunExecutions>>,
  TError,
  { data: V1ListRunExecutionsRequest },
  TContext
> => {
  const mutationKey = ['listRunExecutions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listRunExecutions>>,
    { data: V1ListRunExecutionsRequest }
  > = props => {
    const { data } = props ?? {};

    return listRunExecutions(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListRunExecutionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof listRunExecutions>>
>;
export type ListRunExecutionsMutationBody = V1ListRunExecutionsRequest;
export type ListRunExecutionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Lists the executions for a specific run.
Executions are returned in the order they occurred within the run (oldest first).
The full list is returned in a single response; pagination is not supported because
the number of executions per run is naturally bounded (typically a handful, rarely
exceeding low tens).
 */
export const useListRunExecutions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listRunExecutions>>,
      TError,
      { data: V1ListRunExecutionsRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof listRunExecutions>>,
  TError,
  { data: V1ListRunExecutionsRequest },
  TContext
> => {
  const mutationOptions = getListRunExecutionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Patches the currently failing step in a run with modified code or configuration before resuming.
 */
export const patchRunStep = (
  v1PatchRunStepRequest: V1PatchRunStepRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Run>> => {
  return axios.default.post(
    `/jeeves.v1.RunService/PatchRunStep`,
    v1PatchRunStepRequest,
    options,
  );
};

export const getPatchRunStepMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchRunStep>>,
    TError,
    { data: V1PatchRunStepRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchRunStep>>,
  TError,
  { data: V1PatchRunStepRequest },
  TContext
> => {
  const mutationKey = ['patchRunStep'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchRunStep>>,
    { data: V1PatchRunStepRequest }
  > = props => {
    const { data } = props ?? {};

    return patchRunStep(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchRunStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchRunStep>>
>;
export type PatchRunStepMutationBody = V1PatchRunStepRequest;
export type PatchRunStepMutationError = AxiosError<RpcStatus>;

/**
 * @summary Patches the currently failing step in a run with modified code or configuration before resuming.
 */
export const usePatchRunStep = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchRunStep>>,
      TError,
      { data: V1PatchRunStepRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchRunStep>>,
  TError,
  { data: V1PatchRunStepRequest },
  TContext
> => {
  const mutationOptions = getPatchRunStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * ReplayRun only supports single-phase (Main) automations. The new run takes its
code and version from the request, and inherits the rest from the source run:
user_inputs, invocation_details (so MANUAL stays MANUAL, never TEST), stage, and
exception-handling flags. previous_run is set to the source run so completed book
calls can be replayed from its recordings.
 * @summary Re-executes a prior run's Main phase with updated code, returning a new run.
 */
export const replayRun = (
  v1ReplayRunRequest: V1ReplayRunRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Run>> => {
  return axios.default.post(
    `/jeeves.v1.RunService/ReplayRun`,
    v1ReplayRunRequest,
    options,
  );
};

export const getReplayRunMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replayRun>>,
    TError,
    { data: V1ReplayRunRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replayRun>>,
  TError,
  { data: V1ReplayRunRequest },
  TContext
> => {
  const mutationKey = ['replayRun'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replayRun>>,
    { data: V1ReplayRunRequest }
  > = props => {
    const { data } = props ?? {};

    return replayRun(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplayRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof replayRun>>
>;
export type ReplayRunMutationBody = V1ReplayRunRequest;
export type ReplayRunMutationError = AxiosError<RpcStatus>;

/**
 * @summary Re-executes a prior run's Main phase with updated code, returning a new run.
 */
export const useReplayRun = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof replayRun>>,
      TError,
      { data: V1ReplayRunRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof replayRun>>,
  TError,
  { data: V1ReplayRunRequest },
  TContext
> => {
  const mutationOptions = getReplayRunMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Resumes a run that is waiting for an internal callback (book, timer etc)..
Returns the current state and metadata of the run.
 */
export const resumeRun = (
  v1ResumeRunRequest: V1ResumeRunRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Run>> => {
  return axios.default.post(
    `/jeeves.v1.RunService/ResumeRun`,
    v1ResumeRunRequest,
    options,
  );
};

export const getResumeRunMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeRun>>,
    TError,
    { data: V1ResumeRunRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumeRun>>,
  TError,
  { data: V1ResumeRunRequest },
  TContext
> => {
  const mutationKey = ['resumeRun'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumeRun>>,
    { data: V1ResumeRunRequest }
  > = props => {
    const { data } = props ?? {};

    return resumeRun(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof resumeRun>>
>;
export type ResumeRunMutationBody = V1ResumeRunRequest;
export type ResumeRunMutationError = AxiosError<RpcStatus>;

/**
 * @summary Resumes a run that is waiting for an internal callback (book, timer etc)..
Returns the current state and metadata of the run.
 */
export const useResumeRun = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resumeRun>>,
      TError,
      { data: V1ResumeRunRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resumeRun>>,
  TError,
  { data: V1ResumeRunRequest },
  TContext
> => {
  const mutationOptions = getResumeRunMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Retries the currently failing step in a run without any modifications.
 */
export const retryRunStep = (
  v1RetryRunStepRequest: V1RetryRunStepRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Run>> => {
  return axios.default.post(
    `/jeeves.v1.RunService/RetryRunStep`,
    v1RetryRunStepRequest,
    options,
  );
};

export const getRetryRunStepMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryRunStep>>,
    TError,
    { data: V1RetryRunStepRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryRunStep>>,
  TError,
  { data: V1RetryRunStepRequest },
  TContext
> => {
  const mutationKey = ['retryRunStep'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryRunStep>>,
    { data: V1RetryRunStepRequest }
  > = props => {
    const { data } = props ?? {};

    return retryRunStep(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryRunStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryRunStep>>
>;
export type RetryRunStepMutationBody = V1RetryRunStepRequest;
export type RetryRunStepMutationError = AxiosError<RpcStatus>;

/**
 * @summary Retries the currently failing step in a run without any modifications.
 */
export const useRetryRunStep = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof retryRunStep>>,
      TError,
      { data: V1RetryRunStepRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof retryRunStep>>,
  TError,
  { data: V1RetryRunStepRequest },
  TContext
> => {
  const mutationOptions = getRetryRunStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Skips the currently failing step in a run without any modifications.
The run will resume execution from the next step.
 */
export const skipRunStep = (
  v1SkipRunStepRequest: V1SkipRunStepRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Run>> => {
  return axios.default.post(
    `/jeeves.v1.RunService/SkipRunStep`,
    v1SkipRunStepRequest,
    options,
  );
};

export const getSkipRunStepMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof skipRunStep>>,
    TError,
    { data: V1SkipRunStepRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof skipRunStep>>,
  TError,
  { data: V1SkipRunStepRequest },
  TContext
> => {
  const mutationKey = ['skipRunStep'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof skipRunStep>>,
    { data: V1SkipRunStepRequest }
  > = props => {
    const { data } = props ?? {};

    return skipRunStep(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SkipRunStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof skipRunStep>>
>;
export type SkipRunStepMutationBody = V1SkipRunStepRequest;
export type SkipRunStepMutationError = AxiosError<RpcStatus>;

/**
 * @summary Skips the currently failing step in a run without any modifications.
The run will resume execution from the next step.
 */
export const useSkipRunStep = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof skipRunStep>>,
      TError,
      { data: V1SkipRunStepRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof skipRunStep>>,
  TError,
  { data: V1SkipRunStepRequest },
  TContext
> => {
  const mutationOptions = getSkipRunStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
